export default __webpack_public_path__ + "static/media/k8s.017bafab.svg";